<div class="layout-footer">
    &#169; {{ year }}
    by
    <span class="font-medium ml-2">Toggolac.com</span>
</div>
